import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    UncontrolledTooltip, 
    Table,
    Modal,
    Alert,
    CardTitle,
    Button,
    Container } from "reactstrap";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { useMemo } from "react";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { APPNAME } from 'helpers/url_helper';
import avatar1 from "../../assets/images/users/avatar-1.jpg"

//import images
import vacancy from "../../assets/images/companies/Screenshot_2.png";
import logo from "../../assets/images/logo-dark.png";

import Select from 'react-select';
import countryList from 'react-select-country-list'
import axios from 'axios';
import * as url from "../../helpers/url_helper"
import {HRConfig, HRConfig2, formatDate, downloadBase64File, getContentTypeFromBase64 } from 'helpers/backend_helper';
import { useHistory, useParams } from 'react-router-dom';

    const CreateApplicationDetails = () => {
        const {id} = useParams()
        const [recrProjNo, setRecrProjNo] = useState("")
        const [positionCode, setPositionCode] = useState("")
        const [jobTitle, setJobTitle] = useState("")
        const [quantityRequested, setQuantityRequested] = useState("")
        const [applicationSubmissionDeadline, setApplicationSubmissionDeadline] = useState("")
        const history = useHistory();
        const [projects, setProjects] = useState([])
        const [firstName, setFirstName] = useState('')
        const [lastName, setLastName] = useState('')
        const [middleName, setMiddleName] = useState('')
        const [gender, setGender] = useState('')
        const [email, setEmail] = useState('')
        const [phone, setPhone] = useState('')
        const [country, setCountry] = useState('')
        const [dateofbirth, setDateofBirth] = useState('')
        const [username, setusername] = useState('')
        const [countryResidence, setCountryResidence] = useState('')
        const [address, setAddress] = useState('')
        const [hearaboutus, setHearAboutUs] = useState('')
        const [maritalstatus, setMaritalStatus] = useState('')
        const [nationalID, setNationalID] = useState('')
        const [passport, setPassport] = useState('')
        const [applicantNo, setApplicantNo] = useState('')
        const [isEdit, setIsEdit] = useState(false)
        const [applicantID, setApplicantID] = useState('')
        const options = useMemo(() => countryList().getData(), [])
        const [vacancies, setvacancies] = useState(0)
        const [applications, setapplications] = useState(0)
        const [isLoading, setIsLoading] = useState(false)
        const [rStatus, setRStatus] = useState('')

        const [positionDescription, setPositionDescription] = useState([])
        const [applicantWorkExperience, setApplicantWorkExperience] = useState([])
        const [applicantEducation, setApplicantEducation] = useState([])
        const [applicantCertifications, setApplicantCertifications] = useState([])
        const [positionSkills, setPositionSkills] = useState([])
        const [vacanciesAvailable, setVacanciesAvailable] = useState('')

        const [recruitmentProjectNo, setRecruitmentProjectNo] = useState('')
        const [type, setType] = useState('')
        const [typeCode, setTypeCode] = useState('')
        const [experienceType, setExperienceType] = useState([])
        const [experienceFrom, setExperienceFrom] = useState('')
        const [experienceTo, setExperienceTo] = useState('')
        const [experienceOrganization, setExperienceOrganization] = useState('')
        const [experiencePosition, setExperiencePosition] = useState('')
        const [experienceDuties, setExperienceDuties] = useState('')  
        const [eductypeCode, setEducationTypeCode] = useState('')
        const [educationType, setEducationType] = useState([]) 
        const [educStartDate, setEducStartDate] = useState('')
        const [educAttainmentDate, setEducAttainmentDate] = useState('')
        const [educInstitute, setEducInstitute] = useState('')
        const [educDescription, setEducDescription] = useState('')  
        const [certTypeCode, setCertTypeCode] = useState('')
        const [certType, setCertType] = useState([]) 
        const [certStartDate, setCertStartDate] = useState('')
        const [certAttainmentDate, setCertAttainmentDate] = useState('')
        const [certInstitute, setCertInstitute] = useState('')
        const [certDescription, setCertDescription] = useState('')    
        const [lineSystemId, setLineSystemId] = useState('')
        const [positionTitle, setPositionTitle] = useState('')
        const [closeDate, setCloseDate] = useState('')
        const [lineEtag, setLineEtag] = useState('')

        const [modal_line, setmodal_line] = useState(false)
        const [modal_line2, setmodal_line2] = useState(false)
        const [modal_line3, setmodal_line3] = useState(false)
        const [modal_attachments, setmodal_attachments] = useState(false);
        const [form1, setForm1] = useState({})

        const [loadingFiles, setLoadingFiles] = useState(false)
        const [selectedFile, setSelectedFile] = useState([])
        const [uploadedFiles, setUploadedFiles] = useState([])

        const handleSubmitApplication = () =>{
            Swal.fire({
                title: 'Application Submission Confirmation',
                text: 'You are about to submit your application for review.  We take this process very seriously, and we rely on the information you provide to make informed decisions. We would like to emphasize the importance of providing accurate and truthful information in your application. Any inaccurate or misleading information WILL result in the disqualification of your application from consideration.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Submit!',
                cancelButtonText: 'Cancel',
              }).then((result) => {
                if (result.isConfirmed) {
                    setIsLoading(true)
                    const lNo = {'no': applicantNo}
                    axios.post(url.SUBMITAPPLICATION, JSON.stringify(lNo), HRConfig).then((r)=>{
                        if(r.status == '204'){
                            setIsLoading(false)
                            Swal.fire('Submitted!', 'Application has been submitted successfully.', 'success');
                            history.push("/applications")
                        }else{
                            toastr.error("Could not submit Application" )
                        }
                    }).catch((e)=>{
                        console.log(e)
                        setIsLoading(false)
                    })
                  
                }
              });
            
        }

        const tog_attachments = () => {
            setmodal_attachments(!modal_attachments);
            removeBodyCss();
        }
        const handleSelectedFiles = (e) =>{
            const files = e.target.files
            setSelectedFile(Array.from(files))
        }
        const removeFile = (clickedFile) => {
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            setIsLoading(true)
            axios.delete(`${url.ATTACHDOCUMENTS}(${clickedFile.SystemId})`, Config).then((r)=>{
                toastr.warning('File deleted')
                fetchProjects()
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        };
        const handleDownload = (clickedFile) => {
            
            const base64String = clickedFile.FileContentsBase64;
            const fileName = clickedFile.FileName;
            const fileExtension = clickedFile.FileExtension;
            const contentType = clickedFile.fileContentType;
            downloadBase64File(base64String, fileName, fileExtension, contentType);
           
        }
        const handleSaveFiles = () =>{
            selectedFile.forEach((f)=>{
                const reader = new FileReader();
                reader.readAsDataURL(f);
                reader.onloadend = () => {
                    const base64Data = reader.result;
                    const fileName = f.name;
                    const fileExtension = fileName.split('.').pop();
                    const fileData = {
                        No:applicantNo,
                        TableID:51402340,
                        FileName:fileName,
                        FileExtension: fileExtension,
                        fileContentType:getContentTypeFromBase64(base64Data),
                        FileContentsBase64:base64Data.split(',')[1]
                    }
                    setIsLoading(true)
                    axios.post(url.ATTACHDOCUMENTS, JSON.stringify(fileData), HRConfig).then((r)=>{
                        toastr.info(`${r.data.FileName} has been attached`)
                        tog_attachments()
                        fetchProjects()
                    }).catch((e)=>{ 
                        console.log(e)
                        setIsLoading(false)
                    })
                }
            })
        }

        const handleEditLine = (k) =>{
            const p = applicantEducation[k]
            tog_line2()
            setIsEdit(true)
            setEducationTypeCode(p.TypeCode)
            setEducStartDate(p.StartDate)
            setEducAttainmentDate(p.AttainmentDate)
            setEducInstitute(p.Institute)
            setEducDescription(p.Description)
            setLineSystemId(p.SystemId)
        }

        const handleEditLine2 = (k) =>{
            const p = applicantCertifications[k]
            tog_line3()
            setIsEdit(true)
            setCertTypeCode(p.TypeCode)
            setCertStartDate(p.StartDate)
            setCertAttainmentDate(p.AttainmentDate)
            setCertInstitute(p.Institute)
            setCertDescription(p.Description)
            setLineSystemId(p.SystemId)
        }
        
        const handleUpdateLine = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : typeCode,
                "ExperienceFrom"     : formatDate(experienceFrom),
                "ExperienceTo"       : formatDate(experienceTo),
                "ExperiencePosition" : experiencePosition,
                "ExperienceOrganization"  : experienceOrganization,
                "ExperienceDuties"    : experienceDuties
            }  
            if((experienceDuties.trim().length < 10)){
                toastr.error('Duties/Responsibilities field must have more than 10 characters')
                setIsLoading(false)
            }else if((experienceOrganization.trim().length < 1)){
                toastr.error('Enter the organization you gained this experience from.')
                setIsLoading(false)
            }else if((experiencePosition.trim().length < 1)){
                toastr.error('Enter the Position you held while performing this role.')
                setIsLoading(false)
            }else if((typeCode =="")){
                toastr.error('Type code of experience must not be blank!')
                setIsLoading(false)
            }else if((experienceFrom =="")){
                toastr.error('Experience Start Date must not be blank!')
                setIsLoading(false)
            }else if((experienceTo =="")){
                toastr.error('Experience End Date must not be blank!')
                setIsLoading(false)
            }else{
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.APPLICANT_WORK_EXPERIENCE}(${lineSystemId})`, JSON.stringify(data), Config).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Work Experience line updated')
                    tog_line()
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }
        const handleAddLine2 = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : eductypeCode,
                "StartDate"          : formatDate(educStartDate),
                "AttainmentDate"     : formatDate(educAttainmentDate),
                "Description"        : educDescription,
                "Institute"          : educInstitute
            }  
            if((educDescription.trim().length < 2)){
                toastr.error('Please state what course you did!')
                setIsLoading(false)
            }else if((educInstitute.trim().length < 1)){
                toastr.error('Enter the institute you attained this qualification from!')
                setIsLoading(false)
            }else if((eductypeCode=="")){
                toastr.error('Enter the Qualification Type Code.')
                setIsLoading(false)
            }else if((eductypeCode =="")){
                toastr.error('Academic Type code must not be blank!')
                setIsLoading(false)
            }else if((educStartDate =="")){
                toastr.error('Start Date must not be blank!')
                setIsLoading(false)
            }else if((educAttainmentDate =="")){
                toastr.error('Attainment Date must not be blank!')
                setIsLoading(false)
            }else{
                axios.post(`${url.APPLICANT_EDUCATION}`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Academic Qualifications line added')
                    tog_line2(false)
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }

        const handleUpdateLine2 = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : eductypeCode,
                "StartDate"          : formatDate(educStartDate),
                "AttainmentDate"     : formatDate(educAttainmentDate),
                "Description"        : educDescription,
                "Institute"          : educInstitute
            }  
            if((educDescription.trim().length < 2)){
                toastr.error('Please state what course you did!')
                setIsLoading(false)
            }else if((educInstitute.trim().length < 1)){
                toastr.error('Enter the institute you attained this qualification from!')
                setIsLoading(false)
            }else if((eductypeCode =="")){
                toastr.error('Academic Type code must not be blank!')
                setIsLoading(false)
            }else if((educStartDate =="")){
                toastr.error('Start Date must not be blank!')
                setIsLoading(false)
            }else if((educAttainmentDate =="")){
                toastr.error('Attainment Date must not be blank!')
                setIsLoading(false)
            }else{
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.APPLICANT_EDUCATION}(${lineSystemId})`, JSON.stringify(data), Config).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Academic Qualifications line updated')
                    tog_line2(false)
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }

        const handleAddLine3 = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : certTypeCode,
                "StartDate"          : formatDate(certStartDate),
                "AttainmentDate"     : formatDate(certAttainmentDate),
                "Description"        : certDescription,
                "Institute"          : certInstitute
            }  
            if((certDescription.trim().length < 2)){
                toastr.error('Please state what certification you attained!')
                setIsLoading(false)
            }else if((certInstitute.trim().length < 1)){
                toastr.error('Enter the institute you attained this certification from!')
                setIsLoading(false)
            }else if((certTypeCode =="")){
                toastr.error('Certification Type code must not be blank!')
                setIsLoading(false)
            }else if((certStartDate =="")){
                toastr.error('Start Date must not be blank!')
                setIsLoading(false)
            }else if((certAttainmentDate =="")){
                toastr.error('Attainment Date must not be blank!')
                setIsLoading(false)
            }else{
                axios.post(`${url.APPLICANT_CERTIFICATIONS}`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Certifications line added')
                    tog_line3(false)
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }

        const handleUpdateLine3 = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : certTypeCode,
                "StartDate"          : formatDate(certStartDate),
                "AttainmentDate"     : formatDate(certAttainmentDate),
                "Description"        : certDescription,
                "Institute"          : certInstitute
            }  
            if((certDescription.trim().length < 2)){
                toastr.error('Please state what Certification you are registering!')
                setIsLoading(false)
            }else if((certInstitute.trim().length < 1)){
                toastr.error('Enter the institute you attained this certification from!')
                setIsLoading(false)
            }else if((certTypeCode =="")){
                toastr.error('Certification Type code must not be blank!')
                setIsLoading(false)
            }else if((certStartDate =="")){
                toastr.error('Start Date must not be blank!')
                setIsLoading(false)
            }else if((certAttainmentDate =="")){
                toastr.error('Attainment Date must not be blank!')
                setIsLoading(false)
            }else{
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.APPLICANT_CERTIFICATIONS}(${lineSystemId})`, JSON.stringify(data), Config).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Certifications line updated')
                    tog_line3(false)
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }
  
  
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const changeHandler = countryResidence => {
            setCountryResidence(countryResidence)
        }  
        const clearLineData = () =>{
            setRecruitmentProjectNo('')
            setType('')
            setTypeCode('')
            setExperienceFrom('')
            setExperienceTo('')
            setExperienceOrganization('')
            setExperiencePosition('')
            setExperienceDuties('')
            setLineSystemId('') 
        } 
        const clearLineData2 = () =>{
            setRecruitmentProjectNo('')
            setEducationTypeCode('')
            setEducStartDate('')
            setEducAttainmentDate('')
            setEducDescription('')
            setEducInstitute('')
            setLineSystemId('') 
        } 
        const clearLineData3 = () =>{
            setRecruitmentProjectNo('')
            setCertTypeCode('')
            setCertStartDate('')
            setCertAttainmentDate('')
            setCertDescription('')
            setCertInstitute('')
            setLineSystemId('') 
        } 
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const tog_line2 = () => {
            setmodal_line2(!modal_line2);
            removeBodyCss();
        }
        const tog_line3 = () => {
            setmodal_line3(!modal_line3);
            removeBodyCss();
        }
        const handleUpdateLine1 = (formRow) =>{
            setIsEdit(true)
            tog_line()
            setForm1({})
            setForm1(formRow)
            setTypeCode(formRow.TypeCode)
            setExperienceFrom(formRow.ExperienceFrom)
            setExperienceTo(formRow.ExperienceTo)
            setExperiencePosition(formRow.ExperiencePosition)
            setExperienceOrganization(formRow.ExperienceOrganization)
            setExperienceDuties(formRow.ExperienceDuties)
            setLineEtag(formRow['@odata.etag'])
            setLineSystemId(formRow.SystemId)
          }

          const handleDeleteLine = () =>{
            setIsLoading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
              }
            axios.delete(`${url.APPLICANT_WORK_EXPERIENCE}(${lineSystemId})`, Config).then((r)=>{
                setIsLoading(false)
                toastr.success('Work Experience line deleted')
                tog_line(false)
                fetchProjects()
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }

        const handleDeleteLine2 = () =>{
            setIsLoading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
              }
            axios.delete(`${url.APPLICANT_EDUCATION}(${lineSystemId})`, Config).then((r)=>{
                setIsLoading(false)
                toastr.success('Academic Qualifications line deleted')
                tog_line2(false)
                fetchProjects()
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }

        const handleDeleteLine3 = () =>{
            setIsLoading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
              }
            axios.delete(`${url.APPLICANT_CERTIFICATIONS}(${lineSystemId})`, Config).then((r)=>{
                setIsLoading(false)
                toastr.success('Certifications line deleted')
                tog_line3(false)
                fetchProjects()
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }

        const handleAddLine = () =>{
            setIsLoading(true)

            const data = {
                "ApplicantNo"        : applicantNo,
                "TypeCode"           : typeCode,
                "ExperienceFrom"     : formatDate(experienceFrom),
                "ExperienceTo"       : formatDate(experienceTo),
                "ExperiencePosition" : experiencePosition,
                "ExperienceOrganization"  : experienceOrganization,
                "ExperienceDuties"    : experienceDuties
            }  
            if((experienceDuties.trim().length < 10)){
                toastr.error('Duties/Responsibilities field must have more than 10 characters')
                setIsLoading(false)
            }else if((experienceOrganization.trim().length < 1)){
                toastr.error('Enter the organization you gained this experience from.')
                setIsLoading(false)
            }else if((experiencePosition.trim().length < 1)){
                toastr.error('Enter the Position you held while performing this role.')
                setIsLoading(false)
            }else if((typeCode =="")){
                toastr.error('Type code of experience must not be blank!')
                setIsLoading(false)
            }else if((experienceFrom =="")){
                toastr.error('Experience Start Date must not be blank!')
                setIsLoading(false)
            }else if((experienceTo =="")){
                toastr.error('Experience End Date must not be blank!')
                setIsLoading(false)
            }else{
                axios.post(`${url.APPLICANT_WORK_EXPERIENCE}`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsLoading(false)
                    toastr.success('Work Experience line added')
                    tog_line()
                    fetchProjects()
                }).catch((e)=>{
                    console.log(e)
                    setIsLoading(false)
                })
            }         
            
        }

        const handleSubmit = () =>{
            if(countryResidence == ""){
              toastr.error("Enter your country/region of residence");
            }else if(address.trim() == ""){
              toastr.error('Enter a valid address')
            }else if(hearaboutus == ""){
                toastr.error("Please tell us how you found out about this vaccancy"); 
            }else if(maritalstatus == ""){
              toastr.error('Enter your marital status')
            }else{
              const data = {
                CountryofResidence: countryResidence.label,
                Address2: address,
                HeardAboutus: hearaboutus,
                MaritalStatus: maritalstatus,
                NationalIDNumber: nationalID,
                PassportNo: passport,        
              }
              const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
              }
              setIsLoading(true)
              axios.patch(`${url.APPLICANTS}(${id})`, JSON.stringify(data), Config).then((r)=>{
                  toastr.success('Application updated successfully. Proceed to next section')
                  console.log(r)
                  fetchProjects()
              }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
              })
            }
          }
        
        const fetchProjects = () =>{
            setIsLoading(true)
            /* axios.get(`${url.RECRUITMENTPROJECTSX}(${id})?$expand=positionDescription,positionEducation,positionCertificates,positionSkills`, HRConfig).then((r)=>{
                
                setRecrProjNo(r.data.RecrProjNo)
                setPositionCode(r.data.PositionCode)
                setJobTitle(r.data.jobTitle)
                setQuantityRequested(r.data.QuantityRequested)
                setApplicationSubmissionDeadline(r.data.applicationSubmissionDeadline)
                setPositionDescription(r.data.positionDescription)
                setPositionSkills(r.data.positionSkills)
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            }) */
            axios.get(`${url.APPLICANTS}(${id})?$expand=applicantWorkExperience,applicantEducation,applicantCertifications`, HRConfig)
            .then((r)=>{
                console.log(id)
                setRecrProjNo(r.data.RecruitmentProjectNo)  
                setApplicantNo(r.data.ApplicantNo)
                setPositionCode(r.data.PositionCode)
                setPositionTitle(r.data.PositionTitle)
                setJobTitle(r.data.jobTitle)
                setCountryResidence(r.data.CountryofResidence)
                setAddress(r.data.Address2)
                setHearAboutUs(r.data.HeardAboutus)
                setMaritalStatus(r.data.MaritalStatus)
                setNationalID(r.data.NationalIdNumber)
                setPassport(r.data.PassportNo)
                setRStatus(r.data.Status)
                setQuantityRequested(r.data.QuantityRequested)
                setApplicationSubmissionDeadline(r.data.applicationSubmissionDeadline)
                setPositionDescription(r.data.positionDescription)
                setApplicantEducation(r.data.applicantEducation)
                setApplicantCertifications(r.data.applicantCertifications)
                setPositionSkills(r.data.positionSkills)
                setApplicantWorkExperience(r.data.applicantWorkExperience)
                setRecruitmentProjectNo(r.data.RecruitmentProjectNo)
                setPositionTitle(r.data.PositionTitle)
                setPositionCode(r.data.PositionCode)
                setCloseDate(r.data.CloseDate)
                setQuantityRequested(r.data.QuantityRequested)
                setIsLoading(false)
                setLoadingFiles(true)
                axios.get(`${url.ATTACHDOCUMENTS}?$filter=No eq '${r.data.ApplicantNo}'`, HRConfig).then((r)=>{
                    setUploadedFiles(r.data.value)
                    setLoadingFiles(false)
                }).catch((e)=>{ console.log(e); setLoadingFiles(false) })
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
            axios.get(url.WORKEXPERIENCETYPES, HRConfig).then((r)=>{ 
                setExperienceType(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.EDUCATIONTYPES, HRConfig).then((r)=>{ 
                setEducationType(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.PROFFESSIONAL_CERTIFICATIONS, HRConfig).then((r)=>{ 
                setCertType(r.data.value)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(() => {
            if (localStorage.getItem("authApplicant")) {
                const obj = JSON.parse(localStorage.getItem("authApplicant"))
                setusername(`${obj.fname} ${obj.lname}`)
                setFirstName(`${obj.fname}`)
                setLastName(`${obj.lname}`)
                setMiddleName(`${obj.mname}`)
                setGender(`${obj.gender}`)
                setPhone(`${obj.phone}`)
                setEmail(`${obj.email}`)
                setDateofBirth(`${obj.dateofbirth}`)
                setCountry(`${obj.country}`)
                fetchProjects()
            }
          }, [])

          //MMO New Details page
          return (
            <div className="page-content">
            <MetaTags>
            <title>Vacancy details | {APPNAME}</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title={APPNAME} breadcrumbItem="Vacancy details" />

                {/* ATTACHMENTS MODAL */}
                <Modal isOpen={modal_attachments} toggle={() => { tog_attachments()  }} size="l" centered backdrop={'static'} >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">{ `Files` }</h5>
                        <button type="button"
                            onClick={() => { setmodal_attachments(false); }} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row >
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label htmlFor="floatingnameInput">Attach Files</label>
                                    <input type="file" multiple className="form-control"  onChange={(e)=>handleSelectedFiles(e)}   />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button onClick={() => {  tog_attachments() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                        <button className="btn btn-success" onClick={handleSaveFiles}>Add file...</button>
                    </div>
                </Modal>
                               
                {/* WORK EXPERIENCE MODAL */}
                <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete Work Experience Line`:`Add Work Experience Line` }</h5>
                        <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Type Code</label>
                                <select className="form-select" value={typeCode} onChange={(e)=>setTypeCode(e.target.value)}>
                                    <option value="">Select</option>
                                    {experienceType.map((t,k)=>(
                                    <option value={t.Code} key={k}>{t.Description}</option>
                                ))}
                                </select>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Start Date</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={experienceFrom}
                                    onChange={(date) => setExperienceFrom(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>End Date</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={experienceTo}
                                    onChange={(date) => setExperienceTo(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Position</label>
                                <textarea rows={3} className="form-control"value={experiencePosition} onChange={(e)=>setExperiencePosition(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Organization</label>
                                <textarea rows={3} className="form-control" value={experienceOrganization} onChange={(e)=>setExperienceOrganization(e.target.value)}/>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Duties/Responsibilities</label>
                                <textarea rows={3} className="form-control" value={experienceDuties} onChange={(e)=>setExperienceDuties(e.target.value)}/>
                            </div>
                        </Col>
                    </Row>
                    </div>
                    
                    <div className="modal-footer justify-content-center">
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-danger" onClick={()=>handleDeleteLine()}>Delete line...</button> ))
                        }
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleUpdateLine()}>Update line details...</button> ))
                        }
                        {!isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleAddLine()}>Save line details...</button> ))
                        }
                    </div>
                </Modal>

                {/* EDUCATION MODAL */}
                <Modal isOpen={modal_line2} toggle={() => { tog_line2(); }}  size="l" centered  backdrop={'static'}  >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete Academic Qualifications`:`Add Academic Qualification Line` }</h5>
                        <button type="button"  onClick={() => { setmodal_line2(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Type Code</label>
                                <select className="form-select" value={eductypeCode} onChange={(e)=>setEducationTypeCode(e.target.value)}>
                                    <option value="">Select</option>
                                    {educationType.map((t,k)=>(
                                    <option value={t.Code} key={k}>{t.Description}</option>
                                ))}
                                </select>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Start Date</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={educStartDate}
                                    onChange={(date) => setEducStartDate(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Attainment Date - Planned/Actual</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={educAttainmentDate}
                                    onChange={(date) => setEducAttainmentDate(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Course Name</label>
                                <textarea rows={3} className="form-control"value={educDescription} onChange={(e)=>setEducDescription(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Institute</label>
                                <textarea rows={3} className="form-control" value={educInstitute} onChange={(e)=>setEducInstitute(e.target.value)}/>
                            </div>
                        </Col>
                    </Row>
                    </div>
                    
                    <div className="modal-footer justify-content-center">
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-danger" onClick={()=>handleDeleteLine2()}>Delete line...</button> ))
                        }
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleUpdateLine2()}>Update line details...</button> ))
                        }
                        {!isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleAddLine2()}>Save line details...</button> ))
                        }
                    </div>
                </Modal>

                {/* CERTIFICATIONS MODAL */}
                <Modal isOpen={modal_line3} toggle={() => { tog_line3(); }}  size="l" centered  backdrop={'static'}  >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete Certifications`:`Add Certification Line` }</h5>
                        <button type="button"  onClick={() => { setmodal_line3(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Type Code</label>
                                <select className="form-select" value={certTypeCode} onChange={(e)=>setCertTypeCode(e.target.value)}>
                                    <option value="">Select</option>
                                    {certType.map((t,k)=>(
                                    <option value={t.Code} key={k}>{t.Description}</option>
                                ))}
                                </select>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Start Date</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={certStartDate}
                                    onChange={(date) => setCertStartDate(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Attainment Date - Planned/Actual</label>
                                <Flatpickr
                                    className="form-control pD"
                                    options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        disabled: false
                                    }}
                                    value={certAttainmentDate}
                                    onChange={(date) => setCertAttainmentDate(date)}
                                    />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Course Name</label>
                                <textarea rows={3} className="form-control"value={certDescription} onChange={(e)=>setCertDescription(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Institute</label>
                                <textarea rows={3} className="form-control" value={certInstitute} onChange={(e)=>setCertInstitute(e.target.value)}/>
                            </div>
                        </Col>
                    </Row>
                    </div>
                    
                    <div className="modal-footer justify-content-center">
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-danger" onClick={()=>handleDeleteLine3()}>Delete line...</button> ))
                        }
                        {isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleUpdateLine3()}>Update line details...</button> ))
                        }
                        {!isEdit && (isLoading ? 
                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                            : ( <button type="button" className="btn btn-success" onClick={()=>handleAddLine3()}>Save line details...</button> ))
                        }
                    </div>
                </Modal>
        
                
                <Row>
                    <Col lg="12">
                    <Card>
                        <CardBody>
                        <Row>
                            <Col lg="5">
                            <div className="d-flex">
                                <div className="me-3">
                                <img
                                    src={avatar1}
                                    alt=""
                                    className="avatar-md rounded-circle img-thumbnail"
                                />
                                </div>
                                <div className="flex-grow-1 align-self-center">
                                <div className="text-muted">
                                    <p className="mb-2">Welcome to MILDMAY Job applications portal</p>
                                    <h5 className="mb-1">{username}</h5>
                                    <p className="mb-0">Applicant</p>
                                </div>
                                </div>
                            </div>
                            </Col>

                            <Col lg="7" className="align-self-center">
                            <div className="text-lg-center mt-4 mt-lg-0">
                                <Row>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Vacancies
                                    </p>
                                    <h5 className="mb-0">3</h5>
                                    </div>
                                </Col>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Applications
                                    </p>
                                    <h5 className="mb-0">0</h5>
                                    </div>
                                </Col>
                                
                                </Row>
                            </div>
                            </Col>

                            
                        </Row>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                
            <React.Fragment>
            <Row>
                <Col xl={3}>
                    <Card>
                        <CardBody className="border-bottom">
                        <h5 className="fw-semibold">Overview</h5>
                            <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th scope="col">Project No</th>
                                        <td scope="col"> {recruitmentProjectNo} </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Code</th>
                                        <td scope="col">{positionCode}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Title</th>
                                        <td scope="col">{positionTitle}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Vacancy</th>
                                        <td>{quantityRequested}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Close Date</th>
                                        <td>{closeDate}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Applicant No</th>
                                        <td>{applicantNo}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Status</th>
                                        <td>{rStatus}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                            <div className="hstack gap-2">
                            {/* <button className="btn btn-success btn-block w-100" onClick={handleSharewithFriend}><i className="mdi mdi-share text-primary fs-4"></i>Share with Friend</button> */}
                        </div>
                        </CardBody>
                    </Card>
                    <Card>
                    <CardBody>
                        <div className="text-center">
                            <img src={logo} alt="" height="50" className="mx-auto d-block" />
                            <h5 className="mt-3 mb-1">Uganda Electricity Generation Company Ltd.</h5>
                            <p className="text-muted mb-0">Since 2001</p>
                        </div>

                        <ul className="list-unstyled mt-4">
                            <li>
                                <div className="d-flex">
                                    <i className="bx bx-phone text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Phone</h6>
                                        <p className="text-muted fs-14 mb-0">+256 312 372165</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-mail-send text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Email</h6>
                                        <p className="text-muted fs-14 mb-0">info@MILDMAY.go.ug</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-globe text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Website</h6>
                                        <p className="text-muted fs-14 text-break mb-0">www.MILDMAY.com</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-map text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Location</h6>
                                        <p className="text-muted fs-14 mb-0">Block C Plot 6-9 Okot Close Bukoto Victoria Office</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="hstack gap-2">
                            <Dropdown tag="a" href="https://www.google.com/maps/place/Uganda+Electricity+Generation+Company+Limited/@0.344662,32.593772,15z/data=!4m6!3m5!1s0x177dbbb20980436b:0xfc1d7682397704fa!8m2!3d0.3446615!4d32.5937724!16s%2Fg%2F11dymg3mfm?hl=en&entry=ttu" target="_blank" className="btn btn-primary btn-block w-100" ><i className="mdi mdi-google-maps"/>{" "}View Map</Dropdown>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <CardTitle>Attachments</CardTitle>
                        {loadingFiles ? (
                            <>
                            <div className="text-center">
                                        <div className="mb-4">
                                        </div>
                                        <div>
                                        <h5>Loading files ...</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                            </>
                        ): ((uploadedFiles.length > 0)?(
                            <div className="table-responsive">
                                    <Table className="table table-striped table-sm mb-4">
                                        <thead>
                                            <tr>
                                                
                                                <th>File</th>
                                                
                                                <th></th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uploadedFiles.map((a,k)=>(
                                                <tr key={k}>
                                                    
                                                    <td style={{ verticalAlign: 'middle' }}>
                                                    
                                                    <Link to="#" onClick={()=>handleDownload(uploadedFiles[k])}>{a.FileName}</Link></td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                    
                                                        <div className="d-flex gap-3">
                                                        {(rStatus == 'Open') && (
                                                            <Link
                                                            to="#"
                                                            className="text-danger"
                                                            onClick={() => removeFile(uploadedFiles[k])}
                                                            >
                                                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                Delete
                                                            </UncontrolledTooltip>
                                                            </Link>
                                                            )}
                                                        </div>
                                                    
                                                        </></td>
                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    </div>
                                ):(
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-file text-warning display-4" />
                                        </div>
                                        <div>
                                        <h5>No file attached, yet!</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                                ))}
                        {(rStatus == 'Open') &&  (
                        <>
                        <Row>
                            <div className="hstack gap-2">
                                <button className="btn btn-success btn-block w-100" onClick={tog_attachments}>Attachments</button>
                            </div>
                        </Row>
                        </>
                        )}
                    </CardBody>
                </Card>

                </Col>

                
                <Col xl={9}>
                    <Card>
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">REGISTERED INFORMATION</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <li>
                                            <i className="bx bx-building-house"></i> <span className="text-muted">MILDMAY</span>
                                        </li>
                                        <li>
                                            <i className="bx bx-map"></i> <span className="text-muted">Uganda</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Row>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">First Name</h6>
                                                <p className="text-muted fs-14 mb-0">{firstName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Last Name</h6>
                                                <p className="text-muted fs-14 mb-0">{lastName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Other Names</h6>
                                                <p className="text-muted fs-14 mb-0">{middleName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                            <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-calendar text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Date of Birth</h6>
                                                <p className="text-muted fs-14 mb-0">{dateofbirth}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-globe-alt text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Country/Region of Origin</h6>
                                                <p className="text-muted fs-14 mb-0">{country}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-user text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Gender</h6>
                                                <p className="text-muted fs-14 mb-0">{gender}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-phone text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Phone</h6>
                                                <p className="text-muted fs-14 mb-0">{phone}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-mail-send text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Email</h6>
                                                <p className="text-muted fs-14 mb-0">{email}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            </Row>
                            
                        </CardBody>
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">PERSONAL INFORMATION</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <li>
                                            <i className="bx bx-building-house"></i> <span className="text-muted">MILDMAY</span>
                                        </li>
                                        <li>
                                            <i className="bx bx-map"></i> <span className="text-muted">Uganda</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Row>
                            <Col xl = {4}>
{/*                                 <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-globe text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Country of Residence</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                    <Select options={options} 
                                                        value={countryResidence} 
                                                        onChange={changeHandler}
                                                        placeholder="Select your current country or region of residence.">
                                                    </Select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>  */}
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-home-alt text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Physical Address</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={address} 
                                                    onChange={(e)=>setAddress(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-question-mark text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">How did you hear about us</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <select className="form-select" 
                                                    value={hearaboutus} 
                                                    onChange={(e)=>setHearAboutUs(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="Social Media">Social Media</option>
                                                    <option value="GlassDoor">GlassDoor</option>
                                                    <option value="LinkedIn">LinkedIn</option>
                                                    <option value="Newspaper or Magazine">Newspaper or Magazine</option>
                                                    <option value="MILDMAY Outreach/Career Fair">MILDMAY Outreach/Career Fair</option>
                                                    <option value="Referral from a friend/Colleague">Referral from a friend/Colleague</option>
                                                    <option value="Search Engine">Search Engine</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="mdi mdi-human-male-female text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Marital Status</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <select className="form-select" 
                                                    value={maritalstatus} 
                                                    onChange={(e)=>setMaritalStatus(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="Single">Single</option>
                                                    <option value="Married">Married</option>
                                                    <option value="Divorced">Divorced</option>
                                                    <option value="Separated">Separated</option>
                                                    <option value="Widow">Widow</option>
                                                    <option value="Widower">Widower</option>
                                                </select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="mdi mdi-id-card text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">National ID (Ugandan Citizens only)</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={nationalID} 
                                                    onChange={(e)=>setNationalID(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-book text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Passport Number (Non-Ugandan applicants)</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={passport} 
                                                    onChange={(e)=>setPassport(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <div className="hstack gap-2">
                                <button className="btn btn-success btn-block w-100" onClick={handleSubmit}><i className="mdi mdi-content-save"/>{" "}Edit Personal Details</button>
                        </div>
                            </Row>
                        </CardBody>

                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">WORK EXPERIENCE</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={()=>{setIsEdit(false); clearLineData(); tog_line()}} >
                                                <i className="mdi mdi-home-search-outline"/>{" "}
                                                    Add Work Experience
                                            </Button>
                                        </div>
                                    </ul>
                                </div>
                            </div>

                            {(applicantWorkExperience.length > 0) ? (<>
                                {(applicantWorkExperience || []).map((formRow, key) => (
                                    <Card key={key}>
                                        <CardBody>
                                            <div>
                                                <Row className="mb-3 align-items-center">
                                                <Col sm={4}>
                                                    <div className="fs-14 mb-2">
                                                        <h5>Line {key+1}</h5>                             
                                                        <Row  className="m-1">
                                                            <Col sm={12}><h6  className="text-primary">Type Code</h6></Col>
                                                            <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.TypeCode}</Col>
                                                        </Row>
                                                        <Row  className="m-1">
                                                            <Col sm={12}><h6  className="text-primary">Start Date</h6></Col>
                                                            <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.ExperienceFrom}</Col>
                                                        </Row>
                                                        <Row  className="m-1">
                                                            <Col sm={12}><h6  className="text-primary">End Date</h6></Col>
                                                            <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.ExperienceTo}</Col>
                                                        </Row>
                                                        <Row  className="m-1">
                                                            <Col sm={12}><h6  className="text-primary">Organization</h6></Col>
                                                            <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.ExperienceOrganization}</Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                                <Col sm={8}>
                                                    <Row  className="m-1">
                                                        <Col sm={12}><h6  className="text-primary">Position</h6></Col>
                                                        <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.ExperiencePosition}</Col>
                                                    </Row>
                                                    <Row  className="m-1">
                                                        <Col sm={12}><h6  className="text-primary">Duties/Responsibilities</h6></Col>
                                                        <Col sm={12}><i className="mdi mdi-chevron-right text-primary me-1" />{" "}{formRow.ExperienceDuties}</Col>
                                                    </Row>
                                                    <Button
                                                            type="button"
                                                            color="info"
                                                            className="btn-sm btn-rounded m-3"
                                                            onClick={()=>{handleUpdateLine1(formRow)}}
                                                            >
                                                            Update Line
                                                        </Button>  
                                                </Col>
                                                </Row>
                                            </div>
                                        </CardBody>
                                    </Card>  
                                ))}
                            </>
                            ):(
                                <div className="text-center">
                                    <div className="mb-4">
                                        <i className="mdi mdi-home-search-outline text-warning display-4" />
                                    </div>
                                    <div>
                                        <h5>No Work Experience added, yet!</h5>
                                        <p className="text-muted">     </p>
                                    </div>
                                </div>
                            )}
                        </CardBody>
                       
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">EDUCATION AND ACADEMIC QUALIFICATIONS</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                    <div className="d-grid gap-2">
                                        <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={()=>{setIsEdit(false); clearLineData2(); tog_line2()}} >
                                            <i className="mdi mdi-school-outline"/>{" "}
                                                Add Education and Academic Qualifications
                                        </Button>
                                        </div>
                                    </ul>
                                </div>
                            </div>

                            {(applicantEducation.length > 0) ? (
                                <div className="table-responsive">
                                    <Table  className="table table-striped table-sm mb-4">
                                        <thead>
                                            <tr>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Type Code</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Start Date</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Attainment Date -Planned/Actual</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Course Name</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Institution</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {applicantEducation.map((a,k)=>(
                                                <tr key={k}>

                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.TypeCode}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.StartDate}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.AttainmentDate}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Description}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Institute}</td>
                                                    
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                    {(rStatus == 'Open') && <>
                                                        <div className="d-flex gap-3">
                                                            <Link
                                                            to="#"
                                                            className="text-success"
                                                            onClick={() =>{handleEditLine(k)}}
                                                            >
                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                            <UncontrolledTooltip placement="top" target="edittooltip">
                                                                Edit
                                                            </UncontrolledTooltip>
                                                            </Link>
                                                            
                                                        </div>
                                                        </>}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    </div>
                                ):(
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-school-outline text-warning display-4" />
                                        </div>
                                        <div>
                                        <h5>No Academic Qualifications added, yet!</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                        )}
                            
                        </CardBody>

                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">CERTIFICATIONS</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                    <div className="d-grid gap-2">
                                        <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={()=>{setIsEdit(false); clearLineData3(); tog_line3()}} >
                                            <i className="mdi mdi-certificate-outline"/>{" "}
                                                Add Certifications
                                        </Button>
                                    </div>
                                    </ul>
                                </div>
                            </div>

                            {(applicantCertifications.length > 0) ? (
                                <div className="table-responsive">
                                    <Table  className="table table-striped table-sm mb-4">
                                        <thead>
                                            <tr>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Type Code</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Start Date</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Attainment Date -Planned/Actual</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Certification Name</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Institution</th>
                                                <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {applicantCertifications.map((a,k)=>(
                                                <tr key={k}>

                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.TypeCode}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.StartDate}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.AttainmentDate}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Description}</td>
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Institute}</td>
                                                    
                                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                    {(rStatus == 'Open') && <>
                                                        <div className="d-flex gap-3">
                                                            <Link
                                                            to="#"
                                                            className="text-success"
                                                            onClick={() =>{handleEditLine2(k)}}
                                                            >
                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                            <UncontrolledTooltip placement="top" target="edittooltip">
                                                                Edit
                                                            </UncontrolledTooltip>
                                                            </Link>
                                                        </div>
                                                        </>}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    </div>
                                ):(
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-certificate-outline text-warning display-4" />
                                        </div>
                                        <div>
                                        <h5>No Certifications added, yet!</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                        )}
                            
                        </CardBody>

                    </Card>
                    {(rStatus == 'Open') && (
                        <>
                        <Row>
                            <div className="hstack gap-2">
                                <button className="btn btn-success btn-block w-100" onClick={handleSubmitApplication}>Submit Application</button>
                                <button className="btn btn-primary w-100">Contact Us</button>
                                <button className="btn btn-danger w-100">Delete Application</button>
                            </div>
                        </Row>
                        </>
                    )}
{/*                     <Col xl={6}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">EDUCATION AND ACADEMIC QUALIFICATIONS</h5>
                            {(applicantEducation.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">          
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>     
                                                                                        
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col> */}
{/*                     <Col xl={6}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">CERTIFICATES</h5>
                            {(applicantCertifications.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">        
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>                              
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col> */}
                    {/* <Col xl={3}>
                    <Card>
                        <CardBody>
                        <h5 className="fw-semibold mb-1">SKILLS</h5>
                            {(positionSkills.map((i,k)=>(
                                <Row key={k}>
                                    <Col className="mb-1">
                                            <Row  className="m-1 mb-1">              
                                                    <Col sm={12}>
                                                        <i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.description}
                                                    </Col>                                              
                                            </Row>
                                    </Col>
                                </Row>
                            )))}
                        </CardBody>
                    </Card>
                    </Col> */}
                    
                </Col>
                </Row>
            </React.Fragment>
            
            </Container>
            </div>
        );
    }

export default CreateApplicationDetails;